import React from "react";

export default function Stats() {
  return <div />;
}
